import React from 'react';

const DIvider = () => {
    return (
        <div className='my-8 w-[100%] h-[2px] bg-slate-800'>

        </div>
    );
};

export default DIvider;